import React, {useContext} from "react";
import {ThemeContext} from "../../providers/themeContext/theme-context.tsx";
import {isEmptyOrNullOrUndefined} from "../../common/utils/Datautil.ts";


type Props = {
    className?: string,
    onClick?: () => void,
    avatar?: string,
    avatarFrame?: string,
}

const CustomAvatar: React.FC<Props> = ({className, onClick, avatar, avatarFrame}) => {
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);

    return <div onClick={onClick}
                className={`position-relative ${className} display-flex-column display-flex-align-items-center display-flex-justify-content-center`}>
        {/*头像*/}
        <img
            className="object-fit-contain bg-img-cover-no-repeat-center width-100-percent height-100-percent border-radius-round bg-color-white"
            style={avatarFrame ? {height: '90%', width: '90%'} : {padding: '1px'}}
            src={avatar ?? imgUrls.defaultAvatarUrl} alt="avatar"/>
        {/*头像框*/}
        {avatarFrame && !isEmptyOrNullOrUndefined(avatarFrame) &&
            <img
                // style={{width: '110%', height: '110%'}}
                className="object-fit-contain bg-img-cover-no-repeat-center width-100-percent height-100-percent position-absolute"
                src={avatarFrame} alt="frame"/>}

    </div>;
};

export default CustomAvatar;